import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { SeedingCriteria } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';

/**
 * Service to get and save a wrestling seeding criteria.
 */
@Injectable()
export class SeedingCriteriaService {
    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all the seeding criteria for a given event and division
     */
    public getIndex(eventId: string, divisionId: string, included: string[]): Observable<SeedingCriteria[]> {
        const apiRequestUrl: string = this.getApiUrl(eventId, divisionId, included);

        return this.http.get(apiRequestUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const seedingCriteriaList: SeedingCriteria[] = [];
                const bodyData: any = response.data || [];
                for (const seedingCriteria of bodyData) {
                    seedingCriteriaList.push((new SeedingCriteria()).deserialize(seedingCriteria));
                }
                return seedingCriteriaList;
            }));
    }

    /**
     * Add or update a seeding criteria
     */
    public save(eventId: string, divisionId: string, seedingCriteria: SeedingCriteria): Observable<SeedingCriteria> {
        let response: Observable<IJsonApiResponse>;

        if (!seedingCriteria.isNew) {
            // Update existing Division
            const apiRequestUrl: string = this.getApiUrl(eventId, divisionId) + seedingCriteria.id;
            response = this.http.patch(apiRequestUrl, seedingCriteria.serialize());
        } else {
            // Add a new Division
            const apiRequestUrl: string = this.getApiUrl(eventId, divisionId);
            response = this.http.post(apiRequestUrl, seedingCriteria.serialize());
        }

        return response.pipe(map((response: IJsonApiResponse) => (new SeedingCriteria()).deserialize(response)));
    }

    /**
     * Delete a seeding criteria. This service will fail if a wrestler is linked the seeding criteria to
     * be removed.
     */
    public delete(eventId: string, divisionId: string, seedingCriteriaId: string): Observable<boolean> {
        const apiRequestUrl: string = this.getApiUrl(eventId, divisionId) + seedingCriteriaId;
        return this.http.delete(apiRequestUrl).pipe(map((response: IJsonApiResponse) => true));
    }

    /**
     * Build the api's url based on the given parameters
     */
    private getApiUrl(eventId: string, divisionId: string, includes: string[] = null): string {
        let url: string = `${this.http.configService.getApiBaseUrl()
        }/events/${eventId}/divisions/${divisionId}/seeding-criteria/`;
        url += this.http.getQueryParameters(includes, null);

        return url;
    }
}
